export default class SlickOption {
    constructor() {

        function isSmartPhone() {
            if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
                return true;
            } else {
                return false;
            }
        }

        function clickMove(target) {
            target.addEventListener("click", function (e) {
                e.preventDefault();
                // console.log(e)
                if (flg === false) {
                    flg = true;
                    target.parentNode.classList.add("act");
                } else {
                    flg = false;
                    target.parentNode.classList.remove("act");
                }
            })
        }

        function hoverMove(target) {
            target.addEventListener("mouseenter", function (e) {
                e.preventDefault();
                target.classList.add("act");
            })
            target.addEventListener("mouseleave", function (e) {
                e.preventDefault();
                btn.classList.remove("act");
            })
        }
        const btn = document.querySelector("header .entry");
        const btn_a = document.querySelector("header .entry > a");
        let flg = false;
        console.log(btn)
        if (isSmartPhone() === true) {
            clickMove(btn_a);
        } else {
            hoverMove(btn);
        }

    }
}